// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1J3g3","imageUploader":"EGiftCard_imageUploader__3ugWg"};